import { axiosAjax } from '@app/src/config/axios';

export const photoVignetteService = {
  async post(categoryId: number, json: any): Promise<any> {
    try {
      const formData = new FormData();
      formData.append('image', json);
      const { data } = await axiosAjax.post(
        process.env.API_PHOTO_VIGNETTE
          .replace(':categoryId', '' + categoryId),
        formData
      );
      if (data.error) {
        throw new Error();
      }
      return data.data;
      } catch (e) {
        throw new Error(e);
      }
  }
}
